import React from 'react'
import $ from 'jquery'
import { withRouter } from 'react-router-dom'
import AddCompanyModal from "./modal/AddCompanyModal";

import AsyncSelect from "./common/AsyncSelect";

import Event from "../../utils/Event";
import AuthManager from '../../utils/AuthManager'
import Backend from "../../utils/Backend";
import Currency from "../../utils/Currency";
import General from "../../utils/General";

import moment from "moment";

class Header extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      company: AuthManager.currentUser.company,
      username: AuthManager.currentUser.user.first_name
    }
  }

  componentDidMount() {
    this._loadStats()
  }

  componentWillReceiveProps(nextProps){
    this.setState(nextProps, () => this._loadStats())
  }

  _loadStats(){
    let {
      dateFrom,
      dateTo
    } = this.state

    dateTo = dateTo || moment()
    dateFrom = dateFrom || moment().add(-1, "years")

    Backend.getPaymentBreakdownStats(dateFrom.toISOString(), dateTo.toISOString())
      .then(stats => {
        this.setState({
          stats: stats.admin || stats.association
        })
      })
  }

  _goTo(url) {
    window.$('.dropdown-menu.dropdown-menu-fit').removeClass('show')
    this.props.history.push(url)
  }

  _onLogoutPressed() {
    AuthManager.logout()
    .then(() => {
      this._goTo('/login')
    })
  }

  _renderCurrencies(){
    let {
      stats,
      currencyIndex
    } = this.state

    if(!stats) return null

    setTimeout(function(){ // set equal width
      let maxWidth=0;
      let items = ((stats.total_value_processed).length);
      $('.header .statistics .data').each(function() {
          maxWidth = Math.max(maxWidth, $(this).width());
      });
      maxWidth+= 15;
      $('.header .statistics .items').width(items*maxWidth);
     }, 100);

    return stats.total_value_processed.map((currency, index) => {
      if(!window.General.DefaultCurrency.id){
        window.General.DefaultCurrency = currency.currency
        Event.emit('CURRENCY_CHANGED')
      }
      let anchorClassname = window.General.DefaultCurrency.id === currency.currency.id ? 'btn-primary' : 'btn-secondary'
      return (
        <>
          <a
              className={`data btn ${anchorClassname}`}
              onClick={() => {
                window.General.DefaultCurrency = currency.currency
                Event.emit('CURRENCY_CHANGED')
                this._loadStats()
              }}
            >
              <span className='name'>{currency.currency.name}</span>
              {Currency.format("", currency.total)}
          </a>
        </>
      )
    })

  }

  render() {
    let { username, showCompanyModal, association } = this.state
    let initial = username.charAt(0)

    return (
      <div id="kt_header" className="components header header-fixed">

        <div className={'container-fluid d-flex align-items-stretch justify-content-between'}>

          <div className='statistics'>
            <div className='items'>
              {this._renderCurrencies()}
            </div>
          </div>

          <div className="topbar">

            { AuthManager.isPlatformAdmin() &&
              <div className="topbar-item mr-3">
                <div className="d-flex align-items-center">
                  <label className="mr-3 mb-0 d-none d-md-block">Partner:</label>
                  <div className="select-wrapper w-100 association-selector">
                    <AsyncSelect
                      endpoint={window.Api.Associations}
                      className={'custom-async-select__container'}
                      classNamePrefix={'custom-async-select'}
                      params={{ }}
                      isClearable={true}
                      value={General.getSingleAsyncOption(association)}
                      onSelected={association => {
                        window.General.DefaultAssociation = association
                        this.setState({ association })
                        Event.emit('CURRENCY_CHANGED')
                        Event.emit('ASSOCIATION_CHANGED')
                        this._loadStats()
                      }}
                      getOptions={associations => General.getAsyncOptions(associations)}
                    />
                  </div>
                </div>
              </div>
            }

            <div className="dropdown">
              <div className="topbar-item" data-toggle="dropdown" data-offset="0px,0px" aria-expanded="false">
                <div className="btn btn-icon btn-clean h-40px w-40px btn-dropdown">
                  <span className="svg-icon svg-icon-lg svg-icon-primary">
                    <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="24px"
                         height="24px" viewBox="0 0 24 24" version="1.1">
                      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                        <polygon points="0 0 24 0 24 24 0 24"></polygon>
                        <path
                          d="M12,11 C9.790861,11 8,9.209139 8,7 C8,4.790861 9.790861,3 12,3 C14.209139,3 16,4.790861 16,7 C16,9.209139 14.209139,11 12,11 Z"
                          fill="#000000" fillRule="nonzero" opacity="0.3"></path>
                        <path
                          d="M3.00065168,20.1992055 C3.38825852,15.4265159 7.26191235,13 11.9833413,13 C16.7712164,13 20.7048837,15.2931929 20.9979143,20.2 C21.0095879,20.3954741 20.9979143,21 20.2466999,21 C16.541124,21 11.0347247,21 3.72750223,21 C3.47671215,21 2.97953825,20.45918 3.00065168,20.1992055 Z"
                          fill="#000000" fillRule="nonzero"></path>
                      </g>
                    </svg>
                  </span>
                </div>
              </div>
              <div className="dropdown-menu p-0 m-0 dropdown-menu-right dropdown-menu-anim-up dropdown-menu-lg p-0">
                <div className="d-flex align-items-center p-8 rounded-top">
                  <div
                    className="symbol symbol-md bg-light-primary mr-3 flex-shrink-0"
                    style={{
                      paddingLeft: 10,
                      paddingRight: 10,
                      paddingTop: 5,
                      paddingBottom: 5
                    }}
                  >
                    <span className="font-size-h3 font-weight-boldest">{ initial }</span>
                  </div>
                  <div className="text-dark m-0 flex-grow-1 mr-3 font-size-h5">{username}</div>
                </div>
                <div className="separator separator-solid"></div>
                <div className="navi navi-spacer-x-0 pt-5">
                  <a href="/settings" className="navi-item px-8">
                    <div className="navi-link">
                      <div className="navi-icon mr-2">
                        <span className="svg-icon svg-icon-success">
                          <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink"
                               width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                            <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                              <rect x="0" y="0" width="24" height="24"></rect>
                              <path
                                d="M18.6225,9.75 L18.75,9.75 C19.9926407,9.75 21,10.7573593 21,12 C21,13.2426407 19.9926407,14.25 18.75,14.25 L18.6854912,14.249994 C18.4911876,14.250769 18.3158978,14.366855 18.2393549,14.5454486 C18.1556809,14.7351461 18.1942911,14.948087 18.3278301,15.0846699 L18.372535,15.129375 C18.7950334,15.5514036 19.03243,16.1240792 19.03243,16.72125 C19.03243,17.3184208 18.7950334,17.8910964 18.373125,18.312535 C17.9510964,18.7350334 17.3784208,18.97243 16.78125,18.97243 C16.1840792,18.97243 15.6114036,18.7350334 15.1896699,18.3128301 L15.1505513,18.2736469 C15.008087,18.1342911 14.7951461,18.0956809 14.6054486,18.1793549 C14.426855,18.2558978 14.310769,18.4311876 14.31,18.6225 L14.31,18.75 C14.31,19.9926407 13.3026407,21 12.06,21 C10.8173593,21 9.81,19.9926407 9.81,18.75 C9.80552409,18.4999185 9.67898539,18.3229986 9.44717599,18.2361469 C9.26485393,18.1556809 9.05191298,18.1942911 8.91533009,18.3278301 L8.870625,18.372535 C8.44859642,18.7950334 7.87592081,19.03243 7.27875,19.03243 C6.68157919,19.03243 6.10890358,18.7950334 5.68746499,18.373125 C5.26496665,17.9510964 5.02757002,17.3784208 5.02757002,16.78125 C5.02757002,16.1840792 5.26496665,15.6114036 5.68716991,15.1896699 L5.72635306,15.1505513 C5.86570889,15.008087 5.90431906,14.7951461 5.82064513,14.6054486 C5.74410223,14.426855 5.56881236,14.310769 5.3775,14.31 L5.25,14.31 C4.00735931,14.31 3,13.3026407 3,12.06 C3,10.8173593 4.00735931,9.81 5.25,9.81 C5.50008154,9.80552409 5.67700139,9.67898539 5.76385306,9.44717599 C5.84431906,9.26485393 5.80570889,9.05191298 5.67216991,8.91533009 L5.62746499,8.870625 C5.20496665,8.44859642 4.96757002,7.87592081 4.96757002,7.27875 C4.96757002,6.68157919 5.20496665,6.10890358 5.626875,5.68746499 C6.04890358,5.26496665 6.62157919,5.02757002 7.21875,5.02757002 C7.81592081,5.02757002 8.38859642,5.26496665 8.81033009,5.68716991 L8.84944872,5.72635306 C8.99191298,5.86570889 9.20485393,5.90431906 9.38717599,5.82385306 L9.49484664,5.80114977 C9.65041313,5.71688974 9.7492905,5.55401473 9.75,5.3775 L9.75,5.25 C9.75,4.00735931 10.7573593,3 12,3 C13.2426407,3 14.25,4.00735931 14.25,5.25 L14.249994,5.31450877 C14.250769,5.50881236 14.366855,5.68410223 14.552824,5.76385306 C14.7351461,5.84431906 14.948087,5.80570889 15.0846699,5.67216991 L15.129375,5.62746499 C15.5514036,5.20496665 16.1240792,4.96757002 16.72125,4.96757002 C17.3184208,4.96757002 17.8910964,5.20496665 18.312535,5.626875 C18.7350334,6.04890358 18.97243,6.62157919 18.97243,7.21875 C18.97243,7.81592081 18.7350334,8.38859642 18.3128301,8.81033009 L18.2736469,8.84944872 C18.1342911,8.99191298 18.0956809,9.20485393 18.1761469,9.38717599 L18.1988502,9.49484664 C18.2831103,9.65041313 18.4459853,9.7492905 18.6225,9.75 Z"
                                fill="#000000" fillRule="nonzero" opacity="0.3"></path>
                              <path
                                d="M12,15 C13.6568542,15 15,13.6568542 15,12 C15,10.3431458 13.6568542,9 12,9 C10.3431458,9 9,10.3431458 9,12 C9,13.6568542 10.3431458,15 12,15 Z"
                                fill="#000000"></path>
                            </g>
                          </svg>
                        </span>
                      </div>
                      <div className="navi-text">
                        <div className="font-weight-bold">Settings</div>
                      </div>
                    </div>
                  </a>
                  <div className="navi-separator mt-3"></div>
                  <div className="navi-footer px-8 py-5">
                    <a className="btn btn-light-primary font-weight-bold"
                       onClick={() => this._onLogoutPressed()}
                    >
                      Sign Out
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>

        <AddCompanyModal
          show={showCompanyModal}
          onAdded={() => {
            this.setState({
              showCompanyModal: false
            })
          }}
          onHide={() => {
            this.setState({
              showCompanyModal: false
            })
          }}
        />

      </div>
    )
  }
}

export default withRouter(Header)
